import {inject, injectable} from 'inversify';

import {ChoiceQuestionModel} from '../Question/ChoiceQuestion/ChoiceQuestion.model';
import {QuestionModel} from '../Question/Question.model';
import {TextQuestionModel} from '../Question/TextQuestion/TextQuestion.model';
import {CheckboxesAnswerFactory} from './CheckboxesAnswer/CheckboxesAnswerFactory';
import {MultipleChoiceAnswerFactory} from './MultipleChoiceAnswer/MultipleChoiceAnswer.factory';
import {TextAnswerFactory} from './TextAnswer/TextAnswerFactory';

type Props = {
  question: QuestionModel;
  value: string | string[];
};

@injectable()
export class AnswerFactory {
  constructor(
    @inject(CheckboxesAnswerFactory)
    private readonly checkboxesAnswerFactory: CheckboxesAnswerFactory,
    @inject(MultipleChoiceAnswerFactory)
    private readonly multipleChoiceAnswerFactory: MultipleChoiceAnswerFactory,
    @inject(TextAnswerFactory)
    private readonly textAnswerFactory: TextAnswerFactory,
  ) {}

  create({question, value}: Props) {
    switch (true) {
      case question instanceof ChoiceQuestionModel:
        if (Array.isArray(value)) {
          return this.checkboxesAnswerFactory.create({
            question,
            value,
          });
        } else {
          return this.multipleChoiceAnswerFactory.create({
            question,
            value,
          });
        }
      case question instanceof TextQuestionModel:
        return this.textAnswerFactory.create({
          question,
          value: Array.isArray(value) ? value.join(', ') : value,
        });
      default:
        throw new Error(
          `Unsupported answer type for question type: ${question.type}`,
        );
    }
  }
}
